import React from 'react';

const CircleUserIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-789.000000, -153.000000)" fill="#FFFFFF">
        <g transform="translate(772.000000, 115.000000)">
          <g>
            <g>
              <g transform="translate(17.000000, 38.000000)">
                <g opacity="0.300409226">
                  <circle cx="16" cy="16" r="16"></circle>
                </g>
                <g
                  transform="translate(10.666667, 9.333333)"
                  fillRule="nonzero"
                >
                  <path d="M5.33333333,8 C3.10752688,8 1.33333333,6.21875 1.33333333,4 C1.33333333,1.78125 3.13978495,0 5.33333333,0 C7.52688172,0 9.33333333,1.78125 9.33333333,4 C9.33333333,6.21875 7.52688172,8 5.33333333,8 Z M5.33333333,5.65625 C6.2688172,5.65625 7.04301075,4.90625 7.04301075,3.96875 C7.04301075,3.03125 6.30107527,2.28125 5.33333333,2.28125 C4.39784946,2.28125 3.62365591,3.03125 3.62365591,3.96875 C3.62365591,4.90625 4.3655914,5.65625 5.33333333,5.65625 Z"></path>
                  <path d="M2.84217094e-14,14.6666667 L12,14.6666667 C12,11.721148 9.61218533,9.33333333 6.66666667,9.33333333 L5.33333333,9.33333333 C2.38781467,9.33333333 2.80609874e-14,11.721148 2.84217094e-14,14.6666667 L2.84217094e-14,14.6666667 L2.84217094e-14,14.6666667 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CircleUserIcon;
